import React, { useEffect } from "react";
import axios from "axios";
import Modal from "react-modal"; // Install react-modal for modal functionality

import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown, FaMapMarkerAlt } from "react-icons/fa";
import pipaanlogo from "../assets/pipaanlogo.svg";
import groupimg from "../assets/groupimg.png";
import userimg from "../assets/user.png";
import profileimg from "../assets/profile.png";
import share from "../assets/share.png";
import newsfeed from "../assets/images/icons/newsfeed.png";
import calendar from "../assets/images/icons/calendar.png";
import location from "../assets/images/icons/location.png";
import editcover from "../assets/images/icons/edit-p.svg";
import edit from "../assets/images/icons/edit.png";
import mobile from "../assets/images/icons/mobile.png";
import house from "../assets/images/icons/house.png";
import friendsfollowers from "../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../assets/images/icons/groupandfamily.png";
import chats from "../assets/images/icons/chats.png";
import profile from "../assets/images/icons/profile.png";
import camera from "../assets/images/icons/camera.svg";
import locationicon from "../assets/images/icons/location.png";
import mobileicon from "../assets/images/icons/mobile.png";
import Account from "../assets/images/icons/account-setting.png";
import help from "../assets/images/icons/helpandsupport.png";
import logout from "../assets/images/icons/logout.png";
import notification from "../assets/images/icons/notification.png";
import gallery from "../assets/images/icons/gallery.svg";
import video from "../assets/images/icons/video.svg";
import taguser from "../assets/images/icons/tag-user.svg";
import send from "../assets/images/icons/send.svg";
import global from "../assets/images/icons/global.svg";
import greenglobal from "../assets/images/icons/green-global.png";
import hamburger from "../assets/images/icons/hamburger.png";
import hamburgerclose from "../assets/images/icons/hamburgerclose.png";
import closecircle from "../assets/images/icons/close-circle.png";
import FeedPost from "./feedpost/FeedPost";
import profileData from "./feedpost/profiledata";
import { Menu, X, Bell, User, Home } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "./sidebar/leftsidebar"
import LeftResponsivesidebar from "./sidebar/left-responsive"
import Rightsidebar from "./sidebar/rightsidebar"
import RightResponsivesidebar from "./sidebar/right-responsive"
import Headmenu from "./sidebar/headmenu"
import Sharepost from "./sharepost"
import postone from "../assets/images/post-1.png";
import posttwo from "../assets/images/post-2.png";
import postthree from "../assets/images/post-3.png";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import ReactPlayer from "react-player";
import play from "../assets/play.png";
import viewIcon from "../assets/images/icons/viewIcon.png";
import likeIcon from "../assets/images/icons/likeIcon.png";
import shareIcon from "../assets/images/icons/shareIcon.svg";
import commentIcon from "../assets/images/icons/commentIcon.svg";
import smileyIcon from "../assets/images/icons/Smiley.svg";
import Loacationtick from "../assets/images/icons/location-tick.svg";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function HomePage() {
    const navigate = useNavigate(); // ✅ Initialize navigation function
    const [playingIndex, setPlayingIndex] = useState(null);

    const videoUrls = [
        "https://youtube.com/shorts/G5xF0A-HcnQ?feature=shared", "https://youtube.com/shorts/h8wUVsH9ekU?feature=shared", "https://youtube.com/shorts/6AwVtn0Sxl0?feature=shared", "https://youtube.com/shorts/06w3yBAACyM?feature=shared", "https://youtube.com/shorts/yd5l2a2xLVc?feature=shared", "https://youtube.com/shorts/5sFsjYADiKY?feature=shared", "https://youtube.com/shorts/qL2YS-ULKFc?feature=shared"
    ];
    console.log("Video URLs:", videoUrls);

    const [profileImage, setProfileImage] = useState(profileimg);
    const [coverImage, setCoverImage] = useState(profilebanner);
    const [username, setUsername] = useState("User123");
    const [followers, setFollowers] = useState([]);
    const [bio, setBio] = useState("This is my bio");
    const [dob, setDob] = useState("2000-01-01");
    const [location, setLocation] = useState("New York, USA");
    const [mobile, setMobile] = useState("+1234567890");
    const [isFollowing, setIsFollowing] = useState(false);
    const [postContent, setPostContent] = useState("");
    const [posts, setPosts] = useState([]);  // ✅ Store fetched posts
    const [likedUsers, setLikedUsers] = useState([]); // State to store users who liked a post
    const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
    const [longPressTimeout, setLongPressTimeout] = useState(null); // Timeout for long press
    const [commentInputs, setCommentInputs] = useState({}); // State to store comment inputs for each post
    const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false); // Modal state for comments
    const [comments, setComments] = useState([]); // State to store comments
    const [selectedPostId, setSelectedPostId] = useState(null); // Track the post ID for the modal

    const [expandedPosts, setExpandedPosts] = useState(Array(profileData.length).fill(false)); // Ensure consistent hook call
    // ✅ Define state properly
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState(""); // ✅ Store post content
    const [mediaUrl, setMediaUrl] = useState(""); // ✅ Store media URL (if any)
    const [loading, setLoading] = useState(false); // ✅ Handle loading state
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [taggedUserIds, setTaggedUserIds] = useState([]);  // Store tagged user IDs
    const [showDropdown, setShowDropdown] = useState(false);  // Toggle user list dropdown
    const [filteredUsers, setFilteredUsers] = useState([]);  // Store filtered users
    const [cursorPosition, setCursorPosition] = useState(0);  // Track cursor for dropdown
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [tags, setTags] = useState([]);
    const [showLocationPage, setShowLocationPage] = useState(false);
    const [locationInput, setLocationInput] = useState(""); // State for location input
    const [locationSuggestions, setLocationSuggestions] = useState([]); // State for location suggestions
    const [loadingLocations, setLoadingLocations] = useState(false); // Loading state for locations
    const [selectedLocation, setSelectedLocation] = useState(""); // State for selected location
    const [uploadedMedia, setUploadedMedia] = useState([]);
    const [showTagInput, setShowTagInput] = useState(false);
    const [hasMore, setHasMore] = useState(true);  // ✅ Flag to track if there are more posts
    const [page, setPage] = useState(1);          // ✅ Track current page
    const [token, setToken] = useState(null);
    const [expandedComments, setExpandedComments] = useState({}); // Track visibility of comment sections
    const [followings, setFollowings] = useState([]);
    const [followingsTotal, setFollowingsTotal] = useState(0);  // ✅ Total followings count
    const [followersTotal, setFollowersTotal] = useState(0);    // ✅ Total followers count
    const [followerFollowStatus, setFollowerFollowStatus] = useState({}); // Track follow status for followers
    const [followedUsers, setFollowedUsers] = useState({});  // ✅ Track clicked users
    const [blockedUsers, setBlockedUsers] = useState({}); // Track blocked users

    // ✅ Get User ID from sessionStorage
    const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
    const userId = user ? user.id : null;

    // Function to toggle comment section visibility
    const toggleCommentSection = (postId) => {
        setExpandedComments((prev) => ({
            ...prev,
            [postId]: !prev[postId], // Toggle visibility for the specific post
        }));
    };
    // Function to fetch comments for a post
    const fetchComments = async (postId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

        if (!token) {
            alert("You must be logged in to view comments.");
            return;
        }

        try {
            const response = await axios.post(
                `${API_BASE_URL}/comment/get-comments`,
                {
                    filters: { post_id: postId }, // Add post_id to filters
                    page: 1,
                    limit: 10,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                }
            );

            if (response.data.success) {
                setComments(response.data.result.comments); // Set the list of comments
                setSelectedPostId(postId); // Track the post ID
                setIsCommentsModalOpen(true); // Open the modal
            } else {
                console.error("Failed to fetch comments:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching comments:", error);
        }
    };

    // Function to handle long press on the comment box
    const handleCommentLongPressStart = (postId) => {
        const timeout = setTimeout(() => {
            fetchComments(postId); // Fetch comments on long press
        }, 800); // Trigger after 800ms
        setLongPressTimeout(timeout);
    };

    // Function to cancel long press
    const handleCommentLongPressEnd = () => {
        clearTimeout(longPressTimeout); // Clear the timeout if the press is released early
    };

    // Function to close the comments modal
    const closeCommentsModal = () => {
        setIsCommentsModalOpen(false);
        setComments([]);
    };
    // ✅ Scroll event handler
    const handleScroll = () => {
        if (
            window.innerHeight + document.documentElement.scrollTop + 100 >=
            document.documentElement.scrollHeight
        ) {
            fetchPosts();  // Fetch more posts when scrolled near the bottom
        }
    };

    // ✅ Scroll event listener
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [page, hasMore]);

    // Function to handle like action
    const handleLikeClick = async (postId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

        if (!token || !userId) {
            alert("You must be logged in to like a post.");
            return;
        }

        try {
            const response = await axios.post(
                `${API_BASE_URL}/like/add-like`,
                { post_id: "14", user_id: userId },
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                }
            );

            if (response.data.success) {
                console.log("Post liked successfully:", response.data);
                // Update the like count in the UI
                setPosts((prevPosts) =>
                    prevPosts.map((post) =>
                        post.id === postId
                            ? { ...post, likeCount: (Number(post.likeCount) || 0) + 1 } // Ensure likeCount is treated as a number
                            : post
                    )
                );
            } else {
                console.error("Failed to like post:", response.data.message);
            }
        } catch (error) {
            console.error("Error liking post:", error);
        }
    };

    // Function to fetch users who liked a post
    const fetchLikedUsers = async (postId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

        if (!token) {
            alert("You must be logged in to view likes.");
            return;
        }

        try {
            const response = await axios.post(
                `${API_BASE_URL}/like/get-likes`,
                {
                    filters: { post_id: postId }, // Add post_id to filters
                    page: 0,
                    limit: 0,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                }
            );

            if (response.data.success) {
                setLikedUsers(response.data.result.users); // Set the list of users who liked the post
                setSelectedPostId(postId); // Track the post ID
                setIsModalOpen(true); // Open the modal
            } else {
                console.error("Failed to fetch liked users:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching liked users:", error);
        }
    };

    // Function to handle long press
    const handleLongPressStart = (postId) => {
        const timeout = setTimeout(() => {
            fetchLikedUsers(postId); // Fetch liked users on long press
        }, 800); // Trigger after 800ms
        setLongPressTimeout(timeout);
    };

    // Function to cancel long press
    const handleLongPressEnd = () => {
        clearTimeout(longPressTimeout); // Clear the timeout if the press is released early
    };
    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
        setLikedUsers([]);
    };
    // Function to handle comment input change
    const handleCommentChange = (postId, value) => {
        setCommentInputs((prev) => ({
            ...prev,
            [postId]: value, // Update the comment input for the specific post
        }));
    };

    // Function to handle comment submission
    const handleCommentSubmit = async (postId) => {
        const commentContent = commentInputs[postId]; // Get the comment for the specific post

        if (!commentContent || !token || !userId) {
            alert("Please write a comment and ensure you are logged in.");
            return;
        }

        const requestBody = {
            media_url: [], // Add media if applicable
            post_id: 14,
            // user_id: userId,
            content: commentContent,
        };

        try {
            const response = await axios.post(
                `${API_BASE_URL}/comment/add-comment`,
                requestBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                }
            );

            if (response.data.success) {
                console.log("Comment added successfully:", response.data);
                alert("Comment added successfully!");

                // Optionally clear the comment input for the post
                setCommentInputs((prev) => ({
                    ...prev,
                    [postId]: "",
                }));
            } else {
                console.error("Failed to add comment:", response.data.message);
                alert("Failed to add comment. Please try again.");
            }
        } catch (error) {
            console.error("Error adding comment:", error);
            alert("An error occurred while adding the comment.");
        }
    };
    const handleInputChange = (e) => {
        setContent(e.target.innerText);
    };
    const toggleTagInput = () => {
        setShowTagInput(!showTagInput); // Toggle visibility
    };
    // Handle video selection with preview
    const handleVideoChange = (event) => {
        const files = Array.from(event.target.files);

        // Check if there's already media
        if (uploadedMedia.length > 0) {
            setError('You can only upload either 5 images or 1 video.');
            return;
        }

        // Create preview URL for video
        const newVideo = files.map(file => ({
            file: file, // Store the actual file
            type: 'video',
            url: URL.createObjectURL(file)
        }));

        setUploadedMedia(newVideo);
        setError(''); // Clear any previous errors
    };
    // Handle media selection with preview
    const handleMediaChange = (event) => {
        const files = Array.from(event.target.files);

        // Check if there's already a video
        if (uploadedMedia.some(media => media.type === 'video')) {
            setError('You can only upload either 5 images or 1 video.');
            return;
        }

        // Check if adding new files would exceed the limit
        if (uploadedMedia.length + files.length > 5) {
            setError('You can only upload up to 5 images.');
            return;
        }

        // Create preview URLs for each file
        const newMedia = files.map(file => ({
            file: file, // Store the actual file
            type: file.type.startsWith('image/') ? 'image' : 'video',
            url: URL.createObjectURL(file)
        }));

        setUploadedMedia(prev => [...prev, ...newMedia]);
        setError(''); // Clear any previous errors
    };

    // Upload files function with pre-signed URL generation and S3 upload
    const uploadFiles = async () => {
        if (uploadedMedia.length === 0) return alert("Please select files");

        const fileData = uploadedMedia.map((media) => ({
            fileName: media.file.name,
            fileType: media.file.type
        }));

        try {
            // Step 1: Generate pre-signed URLs
            const response = await axios.post(
                `${API_BASE_URL}/aws/generate-presigned-url`,
                { files: fileData },
                {
                    headers: {
                        'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
                    }
                }
            );

            if (!response.data.success) {
                throw new Error('Failed to generate pre-signed URLs');
            }

            const preSignedUrls = response.data.directory;

            // Step 2: Upload media files to S3
            await Promise.all(
                preSignedUrls.map(async (item, index) => {
                    await axios.put(item.presignedUrl, uploadedMedia[index].file, {
                        headers: {
                            'Content-Type': uploadedMedia[index].file.type,
                            'Content-Encoding': 'binary'
                        }
                    });
                    console.log(`${item.fileName} uploaded successfully`);
                })
            );

            return preSignedUrls.map(item => ({
                media_type: item.fileType.startsWith("image") ? "image" : "video",
                url: item.fileUrl // Extract fileUrl from API response
            }));

        } catch (error) {
            console.error('Upload error:', error);
            setError('Failed to upload files. Please try again.');
            throw new Error('Failed to upload files');
        }
    };
    // Handle post submission
    const handlePost = async () => {
        if (!userId) {
            setError("User ID not found. Please log in again.");
            return;
        }
        if (!content && uploadedMedia.length === 0) {
            setError('Please add content or select media.');
            return;
        }
        setLoading(true);
        setError(null);
        console.log("Selected Location Before API Call:", selectedLocation); // Log the selected location

        try {
            let mediaPayload = [];
            if (uploadedMedia.length > 0) {
                mediaPayload = await uploadFiles(); // Get uploaded media URLs
            }


            const response = await axios.post(
                `${API_BASE_URL}/post/add-post`,
                {
                    media_url: mediaPayload,
                    content,
                    tagged_user_ids: taggedUserIds,
                    location: selectedLocation, // Include selected location

                },
                {
                    headers: {
                        'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
                    }
                }
            );

            if (!response.data.success) {
                throw new Error('Failed to add post');
            }

            setIsPopupOpen(false);
            setContent('');
            setUploadedMedia([]);
            setTaggedUserIds([]);
            setSelectedLocation(""); // Clear selected location

            // Refresh posts if needed
            if (fetchPosts) {
                fetchPosts();
            }
        } catch (error) {
            console.error('Failed to add post:', error);
            setError('Failed to add post. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const fetchFollowers = async () => {
        setLoading(true);
        setError(null);

        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve the token from sessionStorage

        const requestBody = {
            filters: { allFollowers: true }, // Add a filter to fetch followers
            page: 1,
            limit: 10, // Adjust the limit as needed
        };

        try {
            const response = await axios.post(
                `${API_BASE_URL}/friend/get-friends`,
                requestBody,
                {
                    headers: {
                        "token": `${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.success) {
                const followersData = response.data.result.friends.map((friend) => ({
                    id: friend.id,
                    first_name: friend.User1.first_name,
                    last_name: friend.User1.last_name,
                    username: friend.User1.username,
                    profile_picture_url: friend.User1.profile_picture_url || userimg,
                    mutualFriendsCount: friend.mutualFriendsCount || 0,
                    user1FollowersCount: friend.User1FollowersCount || 0,
                    isBlocked: friend.isBlocked || false,
                    myStatus: friend.myStatus || null,
                    friendStatus: friend.friendStatus || null,
                }));

                setFollowers(followersData); // Update the followers state
            } else {
                setError("Failed to fetch followers.");
            }
        } catch (error) {
            console.error("Error fetching followers:", error);
            setError("An error occurred while fetching followers.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    useEffect(() => {
        fetchFollowers(); // Fetch followers when the component mounts
    }, []);
    // const fetchPosts = async () => {
    //     setLoading(true);
    //     setError(null);

    //     const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    //     const requestBody = {
    //         filters: {},
    //         page: 1,
    //         limit: 10
    //     };

    //     try {
    //         const response = await axios.post(
    //             `${API_BASE_URL}/post/get-posts`,
    //             requestBody,
    //             {
    //                 headers: {
    //                     "token": `${token}`,
    //                     "Content-Type": "application/json"
    //                 }
    //             }
    //         );

    //         if (response.data.success) {
    //             setPosts(response.data.result.posts);  // ✅ Store posts
    //         } else {
    //             setError("Failed to fetch posts.");
    //         }
    //     } catch (error) {
    //         console.error("❌ Error fetching posts:", error);
    //         setError("An error occurred while fetching posts.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    // ✅ Function to fetch posts
    const fetchPosts = async () => {
        if (loading || !hasMore) return;  // Prevent multiple calls

        setLoading(true);
        setError(null);

        // ✅ Retrieve both tokens dynamically
        const emailToken = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        //  const mobileToken = sessionStorage.getItem("accessTokenMobile");

        // ✅ Use mobile token if available, otherwise fallback to email token
        const activeToken = emailToken;

        if (!activeToken) {
            console.error("❌ No authentication token found.");
            setError("Authentication token is missing. Please log in again.");
            setLoading(false);
            return;
        }
        const requestBody = {
            filters: { user_id: userId }, // Add user_id filter
            page: 1,
            limit: 200
        };

        try {
            const response = await fetch(`${API_BASE_URL}/post/get-posts`, {
                method: "POST",
                headers: {
                    "token": `${activeToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok && data.success) {
                const newPosts = data.result.posts;

                // ✅ Append new posts to the existing ones
                setPosts((prevPosts) => [...prevPosts, ...newPosts]);

                // ✅ Check if there are more posts to load
                setHasMore(newPosts.length === 10);  // Continue if 10 posts are returned
                setPage((prevPage) => prevPage + 1);  // Increment the page
            } else {
                setError("Failed to fetch posts.");
            }
        } catch (error) {
            console.error("❌ Error fetching posts:", error);
            setError("An error occurred while fetching posts.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        const now = new Date();
        const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const formatted = now.toLocaleString('en-US', options).replace(',', '');
        setCurrentDateTime(formatted);
    }, []);

    const handleContentChange = (e) => {
        const value = e.target.value;
        setContent(value);

        const position = e.target.selectionStart;
        setCursorPosition(position);

        const lastWord = value.slice(value.lastIndexOf(" ") + 1);

        if (lastWord.startsWith("@")) {
            setShowDropdown(true);

            if (!followers?.length) {
                fetchFollowers();
            }

            const query = lastWord.slice(1).toLowerCase();
            const filtered = followers.filter((user) =>
                user.first_name.toLowerCase().includes(query)
            );
            setFilteredUsers(filtered);
        } else {
            setShowDropdown(false);
        }
    };

    const handleTagUser = (user) => {
        const tag = `@${user.first_name}`;
        setContent((prev) => prev + ` ${tag} `);

        // ✅ Add the user's ID to the taggedUserIds array
        setTaggedUserIds((prevIds) => [...new Set([...prevIds, user.id])]);
        setShowDropdown(false);
    };

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const toggleReadMore = (index) => {
        setExpandedPosts((prev) => {
            const updated = [...prev];
            updated[index] = !updated[index]; // Toggle specific post
            return updated;
        });
    };
    const [activeTab, setActiveTab] = useState("Interests");


    const handleCoverChange = (e) => {
        const file = e.target.files[0];
        if (file && ["image/jpeg", "image/png", "image/jpg"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
            setCoverImage(URL.createObjectURL(file));
        }
    };

    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserProfile = async () => {
            const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve token
            console.log("Retrieved Token in home page:", token); // ✅ Log token to verify

            if (!token) {
                console.log("Token not found, waiting...");
                setError("Authentication token not found!");
                return;
            }

            try {
                const response = await fetch(`${API_BASE_URL}/user/profile`, {
                    method: "GET",
                    headers: {
                        "token": `${token}`, // ✅ Ensure proper format
                        "Content-Type": "application/json"
                    }
                });

                console.log("API Response Status:", response.status); // ✅ Log status
                if (!response.ok) {
                    const errorData = await response.json();
                    console.error("❌ API Error Data:", errorData);
                    setError(errorData.message || "Failed to fetch user profile");
                    return;
                }

                const data = await response.json();
                console.log("✅ API Success Response from profile page:", data); // ✅ Log full response
                setUserData(data.result);
            } catch (err) {
                console.error("❌ Fetch API Error:", err);
                setError("An error occurred while fetching the profile");
            }
        };

        fetchUserProfile();
    }, []); // ✅ Keep useEffect dependency empty


    // useEffect(() => {
    //     console.log("Updated userData:", userData); // Log userData when it updates
    // }, [userData]);

    const handleFollowClick = async (userId, privacyStatus) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

        if (!token) {
            console.error("No token found. Please log in.");
            return;
        }

        try {
            const response = await axios.post(
                `${API_BASE_URL}/friend/add-friend`,
                {
                    status: "pending",
                    user_id: userId
                },
                {
                    headers: {
                        "token": `${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data.success) {
                console.log("✅ Friend request sent successfully:", response.data);

                // ✅ Update UI dynamically
                setPosts((prevPosts) =>
                    prevPosts.map((post) =>
                        post.user_id === userId
                            ? {
                                ...post,
                                myStatus: privacyStatus === "public" ? "accepted" : "pending" // ✅ Public -> "Following", Private -> "Requested"
                            }
                            : post
                    )
                );
            } else {
                console.error("❌ Failed to send friend request:", response.data.message);
            }
        } catch (error) {
            console.error("❌ Error sending friend request:", error);
        }
    };
    const handleFollowerAction = async (friendId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (!token) return console.error("No token found, please log in.");

        // ✅ Get `user1id` from state instead of sessionStorage
        const user = followers.find((f) => f.id === friendId);
        if (!user || !user.user1id) {
            console.error("User1 ID not found.");
            return;
        }

        console.log("UserID being sent:", user.user1id); // ✅ Debugging log

        try {
            const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": `${token}`,
                },
                body: JSON.stringify({
                    status: "pending",    // ✅ Use "unfollow" status
                    user_id: user.user1id
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            // Update follow status in state
            setFollowerFollowStatus((prev) => ({
                ...prev,
                [friendId]: true, // Mark the user as followed
            }));

            // Refresh followers and followings lists
            fetchFollowers();
            fetchFollowings();

        } catch (error) {
            console.error("Error handling follower action:", error);
        }
    };
    const handleUnblockFollower = async (friendId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (!token) return console.error("No token found, please log in.");

        // ✅ Show confirmation popup
        const isConfirmed = window.confirm("Are you sure you want to unblock this user?");
        if (!isConfirmed) return; // Stop execution if user cancels
        // ✅ Get `user1id` from state instead of sessionStorage
        const user = followers.find((f) => f.id === friendId);
        if (!user || !user.user1id) {
            console.error("User1 ID not found.");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": `${token}`,
                },
                body: JSON.stringify({
                    status: "unblock",   // ✅ Use "blocked" status
                    user_id: user.user1id,
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            console.log(`✅ Unblocked user ID: ${friendId}`);

            // ✅ Update UI to show Follow/Block buttons again
            setFollowers((prev) =>
                prev.map((user) =>
                    user.id === friendId ? { ...user, isBlocked: false } : user
                )
            );

        } catch (error) {
            console.error("❌ Error unblocking:", error);
        }
    };
    const handleUnfollow = async (friendId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (!token) return console.error("No token found, please log in.");
        // ✅ Show confirmation popup
        const isConfirmed = window.confirm("Are you sure you want to unfollow this user?");
        if (!isConfirmed) return; // Stop execution if user cancels

        // ✅ Retrieve the user2id from sessionStorage
        const user2IdMap = JSON.parse(sessionStorage.getItem("user2IdMap") || localStorage.getItem("user2IdMap")) || {};

        // Get the corresponding user2id from the friendId
        const user2id = user2IdMap[friendId];

        if (!user2id) {
            console.error(`User2 ID not found for friend ID: ${friendId}`);
            return;
        }
        try {
            const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": `${token}`,
                },
                body: JSON.stringify({
                    status: "deleted",    // ✅ Use "unfollow" status
                    user_id: user2id,
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            console.log(`Unfollowed user ID: ${user2id}`);

            // ✅ Remove the user from the followings state
            setFollowings((prev) => prev.filter((user) => user.id !== friendId));

        } catch (error) {
            console.error("Error unfollowing:", error);
        }
    };
    const handleBlockFollower = async (friendId) => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (!token) return console.error("No token found, please log in.");

        // ✅ Show confirmation popup
        const isConfirmed = window.confirm("Are you sure you want to block this user?");
        if (!isConfirmed) return; // Stop execution if user cancels

        // ✅ Retrieve the user2id from sessionStorage
        const user1IdMap = JSON.parse(sessionStorage.getItem("user1IdMap")) || {};

        // Get the corresponding user2id from the friendId
        const user1id = user1IdMap[friendId];

        if (!user1id) {
            console.error(`User2 ID not found for friend ID: ${friendId}`);
            return;
        }
        try {
            const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": `${token}`,
                },
                body: JSON.stringify({
                    status: "blocked",   // ✅ Use "blocked" status
                    user_id: user1id,
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            console.log(`Blocked user ID: ${user1id}`);

            // ✅ Remove the user from the followings state
            // setFollowings((prev) => prev.filter((user) => user.id !== friendId));

            // ✅ Update UI to show "Unblock" instead of Unfollow/Block
            setFollowers((prev) =>
                prev.map((user) =>
                    user.id === friendId ? { ...user, isBlocked: true } : user
                )
            );

            // window.location.reload();

        } catch (error) {
            console.error("Error blocking:", error);
        }
    };
    const handleFollowBack = (friendId) => {
        handleFollowerAction(friendId); // Call API function to follow
        setFollowedUsers((prev) => ({ ...prev, [friendId]: true })); // Mark as followed
    };
    // ✅ Fetch Followings
    const fetchFollowings = async () => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (!token) return console.error("No token found, please log in.");
        const userID = sessionStorage.getItem("userID");

        try {
            const response = await fetch(`${API_BASE_URL}/friend/get-friends`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": `${token}`,
                },
                body: JSON.stringify({
                    filters: { allFollowings: true },
                    page: 1,
                    limit: 10,
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);
            const data = await response.json();
            console.log("Followings Response:", data.result);   // ✅ Debugging log

            // ✅ Store user2id with corresponding friend_id in sessionStorage
            const user2IdMap = data.result.friends.reduce((acc, friend) => {
                acc[friend.id] = friend.User2.id;  // friend_id => user2id
                return acc;
            }, {});

            sessionStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
            localStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
            // ✅ Ensure you're extracting the correct total count
            const totalFollowings = data.result.total || 0;
            setFollowingsTotal(totalFollowings);
            const formattedFollowings = data.result.friends.map((friend) => ({
                id: friend.id,
                friend_id: friend.id,
                first_name: friend.User2.first_name,
                user2id: friend.User2.id,

                username: friend.User2.username,
                profile_picture_url: friend.User2.profile_picture_url || userimg,
                mutualFriendsCount: friend.mutualFriendsCount || 0,
            }));
            console.log("formattedFollowings::", formattedFollowings)
            setFollowings(formattedFollowings);
        } catch (error) {
            console.error("Error fetching followings:", error);
        }
    };

    return (

        <div className="dashboard w-full min-h-screen  flex">
            {/* Sidebar */}
            <Leftsidebar />


            <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8 ">
                <LeftResponsivesidebar />
                <Headmenu />
                {/* Main Content */}
                <main className="block lg:grid lg:grid-cols-[78%_20%]">

                    {/* Feeds */}
                    <div className="flex-1 lg:pr-5 space-y-6">

                        <div className="profile-content ">
                            <div className="relative w-full">
                                {/* Cover Photo */}
                                {/* Cover Photo */}
                                <img
                                    src={userData?.cover_picture_url || profilebanner} // Use API cover picture or fallback
                                    alt="Cover"
                                    className="w-full object-cover max-h-[300px] rounded-xl"
                                />
                                {/* Edit Button */}
                                <button className="edit-cover absolute top-0 right-12 bg-[#FFFFFF80] bg-opacity-50 text-[#161F28] px-4 py-2 text-sm flex items-center space-x-2 hover:bg-opacity-75 transition">
                                    <img src={editcover} alt="edit" className="w-4 h-4" />
                                    <span>Edit Cover</span>
                                </button>
                            </div>

                            {profileData.map((post, index) => {
                                const maxLength = 150; // Character limit
                                const isExpanded = expandedPosts[index]; // Always read from state array

                                const handleImageChange = (event) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                        const imageUrl = URL.createObjectURL(file);
                                        post.profileimg = imageUrl; // Update the profile image dynamically
                                    }
                                };

                                return (
                                    <div className=" space-y-3 mt-7 profile-body relative">
                                        <div className="flex items-end relative sm:absolute sm:left-5">
                                            <div className="profile-dashboard profile-page-dashboard overflow-hidden relative">
                                                {/* Profile Image Upload */}
                                                <label className="relative cursor-pointer">
                                                    <input type="file" accept="image/*" className="hidden" onChange={handleImageChange} />
                                                    {/* Profile Image */}
                                                    <img
                                                        src={userData?.profile_picture_url || profileimg} // Use API profile picture or fallback
                                                        alt="Profile"
                                                        className="w-full h-full object-cover"
                                                    />                                                    {/* Camera Icon Overlay */}
                                                    <div className="absolute">
                                                        <img src={camera} alt="Edit" className=" text-white" />
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="feed-title pl-4 relative">
                                                <p className="font-semibold text-[20px]">{userData?.first_name} {userData?.last_name || "N/A"}</p>
                                                <p className="text-sm text-[#747474]">@{userData?.username || "N/A"}</p>
                                                <p className="text-sm text-[#747474]">{userData?.totalFollowers || 0} Followers</p>

                                                <p className="flex text-sm text-[#747474]">
                                                    <span className="flex items-center followers-profile ml-1 cursor-pointer">
                                                        {post.followerImages?.slice(0, 4).map((img, index) => (
                                                            <img
                                                                key={index}
                                                                src={img}
                                                                alt={`Follower ${index + 1}`}
                                                                className="w-6 h-6 rounded-full border-2 border-white -ml-2 first:ml-0"
                                                            />
                                                        ))}
                                                        {/* <span className="ml-2">{post.followers} Followers</span> */}
                                                    </span>
                                                </p>
                                            </div>

                                        </div>
                                        <div className="user-intro ">
                                            <div className="user-intro-flex  mt-5">
                                                <div className="intro">
                                                    <h4 className="font-semibold">Intro</h4>
                                                    {/* <p>{post.intro}</p> */}
                                                    {userData ? (
                                                        <>
                                                            <p className="flex items-center mb-5">
                                                                <p>{userData.bio || "N/A"}</p>
                                                            </p>
                                                        </>
                                                    ) : (
                                                        <p>Loading user details...</p>
                                                    )}
                                                </div>


                                                <div className="user-details pb-5 pl-5">
                                                    {userData ? (
                                                        <>
                                                            <p className="flex items-center mb-5">
                                                                <img src={calendar} className="mr-2" /> DOB
                                                                <b className="font-semibold ml-1">{userData.date_of_birth || "N/A"}</b>
                                                            </p>
                                                            <p className="flex items-start mb-5">
                                                                <img src={house} className="mr-2" /> <nobr>Lives in</nobr>
                                                                <b className="font-semibold ml-1">{userData.location || "N/A"}</b>
                                                            </p>
                                                            <p className="flex items-center mb-5">
                                                                <img src={locationicon} className="mr-2" /> Country of Origin
                                                                <b className="font-semibold ml-1">{userData.country || "N/A"}</b>
                                                            </p>
                                                            <p className="flex items-center mb-5">
                                                                <img src={mobileicon} className="mr-2" /> Phone No
                                                                <b className="font-semibold ml-1">{userData.mobile_number || "N/A"}</b>
                                                            </p>
                                                            <button
                                                                className="flex items-center space-x-2 bg-green-900 text-white px-4 py-2 rounded-full text-sm font-medium edit-profile-cta"
                                                                onClick={() => navigate("/myprofileedit")} // ✅ Redirect on click
                                                            >
                                                                <img src={edit} className="mr-2" />
                                                                <span>Edit Profile</span>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <p>Loading user details...</p>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            {/* Create Post */}

                            <div className="share-content relative">
                                <div className="relative">
                                    {/* Profile Image Inside Textarea */}
                                    <img
                                        src={profileimg}
                                        alt="Profile"
                                        className="prf absolute left-5 top-5 lg:w-10 lg:h-10 rounded-full"
                                    />
                                    <textarea
                                        placeholder="Share something..."
                                        className=" share-input-field share-input-field-profile focus:outline-none focus:ring-2 focus:ring-gray-300 resize-none"
                                        value={content}
                                        onChange={(e) => setContent(e.target.value)}
                                        // onChange={handleContentChange}  // ✅ Use the new handler

                                        onClick={openPopup} // 🔹 Open popup when clicked
                                    ></textarea>
                                    {showDropdown && (
                                        <div style={{ position: "absolute", top: `${cursorPosition + 20}px`, left: "10px", zIndex: 10, background: "white", border: "1px solid #ccc", padding: "10px" }}>
                                            {filteredUsers?.length > 0 ? (
                                                filteredUsers.map((user) => (
                                                    <div key={user.id} onClick={() => handleTagUser(user)} style={{ padding: "5px", cursor: "pointer" }}>
                                                        {user.first_name}
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No users found</p>
                                            )}
                                        </div>
                                    )}

                                </div>
                                {/* ✅ Error Message */}
                                {error && <p className="text-red-500 mt-2">{error}</p>}
                                <div className="flex flex-wrap gap-2 justify-between items-center mt-2">
                                    {/* Left Section (Image, Video, Tag Buttons) */}
                                    <div className="flex">
                                        <input
                                            type="file"
                                            accept="image/*, video/*"
                                            onChange={handleMediaChange}

                                            hidden
                                            id="fileUpload"
                                        />
                                        <button onClick={() => document.getElementById("fileUpload").click()} className="flex items-center px-4 py-2 rounded-lg mr-2">
                                            <img src={gallery} alt="Gallery" className="pr-2" /> Image
                                        </button>
                                        <button className="flex items-center px-4 py-2 rounded-lg">
                                            <img src={video} alt="Video" className="pr-2" /> Video
                                        </button>
                                        <button className="flex items-center px-4 py-2 rounded-lg">
                                            <img src={taguser} alt="Tag" className="pr-2" /> Tag
                                        </button>
                                    </div>

                                    {/* Right Section (Dropdown & Post Button) */}
                                    <div className="flex items-center">
                                        {/* Public Dropdown */}
                                        <div>
                                            <button
                                                onClick={toggleDropdown}
                                                className="share-public flex items-center px-4 py-2"
                                            >
                                                <img src={global} alt="Globe" className="pr-2" />
                                                Public
                                                <FaChevronDown className="ml-2 text-xs text-gray-400" />
                                            </button>

                                            {/* ✅ Show dropdown only if isOpen is true */}
                                            {isOpen && (
                                                <div className="absolute top-12 left-0 bg-white shadow-md rounded-md w-40 p-2">
                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                                                </div>
                                            )}
                                        </div>

                                        {/* Post Button */}
                                        <button onClick={handlePost} className="post-cta flex md:px-4 md:py-2 rounded-lg" disabled={loading} // ✅ Disable button when loading
                                        >
                                            {loading ? "Posting..." : (
                                                <>
                                                    <img src={send} alt="Send" className="md:pr-2" /> <span>Post</span>
                                                </>
                                            )}
                                        </button>
                                    </div>


                                </div>
                            </div>

                            {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
                            {
                                isPopupOpen && (
                                    <div className="popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                                        <div className="border-popup bg-white rounded-lg  relative">
                                            <div className="flex justify-between">
                                                <div className="logo-popup flex items-center justify-center space-x-2 ">
                                                    <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
                                                </div>
                                                {/* Close Button */}
                                                <button className="close-pop-x relative  text-gray-500" onClick={() => setIsPopupOpen(false)}
                                                >
                                                    <img src={closecircle} alt="Nyawoo Logo" className="w-10 h-10" />
                                                </button>
                                            </div>

                                            {/* Modal Content */}
                                            <div className="share-content-modal relative w-full">
                                                <div className="absolute flex pb-5">
                                                    {/* Profile Image Inside Textarea */}
                                                    <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                                                        <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                                                    </div>
                                                    <div className="feed-title pl-4">
                                                        <p className="font-semibold">
                                                            {userData.first_name || "Loading..."}

                                                        </p>                                                        <p className="flex text-sm text-[#747474]">
                                                            {currentDateTime || "Loading..."}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="relative">
                                                    <div
                                                        contentEditable
                                                        placeholder="Share something..."
                                                        onInput={handleInputChange}
                                                        className="share-input-field focus:outline-none focus:ring-0 resize-none p-3 rounded-lg min-h-[200px]"
                                                        suppressContentEditableWarning={true}
                                                    >
                                                        {/* Remove nested content like <div>{content}</div> */}
                                                    </div>
                                                    {/* Display tags outside editable div */}
                                                    <div className="mt-3 flex flex-wrap">
                                                        {tags.map((tag, index) => (
                                                            <span
                                                                key={index}
                                                                className={`px-1 py-1 ml-1 mr-2 mt-2 rounded-lg ${tag.startsWith('#')
                                                                    ? 'bg-[#4988528a] text-[#095228]'
                                                                    : 'bg-[#FFE484] text-[#98911F]'
                                                                    }`}
                                                            >
                                                                {tag}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                                {showDropdown && (
                                                    <div style={{ position: "absolute", top: `${cursorPosition + 20}px`, left: "10px", zIndex: 10, background: "white", border: "1px solid #ccc", padding: "10px" }}>
                                                        {filteredUsers?.length > 0 ? (
                                                            filteredUsers.map((user) => (
                                                                <div key={user.id} onClick={() => handleTagUser(user)} style={{ padding: "5px", cursor: "pointer" }}>
                                                                    {user.first_name}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No users found</p>
                                                        )}
                                                    </div>
                                                )}
                                                {/* Display Uploaded Media Preview */}
                                                <div className="mt-4 share-content-media">
                                                    <div className="flex gap-2 flex-wrap">
                                                        {uploadedMedia.map((media, index) => (
                                                            <div key={index} className="relative">
                                                                {media.type === 'image' ? (
                                                                    <img
                                                                        src={media.url}
                                                                        alt={`Preview ${index + 1}`}
                                                                        className="rounded-lg max-w-[244px] h-max max-h-[244px] object-cover"
                                                                    />
                                                                ) : (
                                                                    <video
                                                                        src={media.url}
                                                                        controls
                                                                        className="rounded-lg max-w-[244px] h-max max-h-[244px]"
                                                                    />
                                                                )}
                                                                <button
                                                                    onClick={() => {
                                                                        setUploadedMedia(prev => prev.filter((_, i) => i !== index));
                                                                        URL.revokeObjectURL(media.url);
                                                                    }}
                                                                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
                                                                >
                                                                    <FaTimes />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {error && <p className="text-red-500 mt-2">{error}</p>}
                                                </div>
                                                <div className="input-cta-post flex justify-between items-start mt-2">
                                                    {/* Left Section (Image, Video, Tag Buttons) */}
                                                    <div className="flex">

                                                        {/* Image Upload */}
                                                        <label className="flex items-center px-4 py-2 rounded-lg mr-2 cursor-pointer">
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                multiple
                                                                className="hidden"
                                                                onChange={handleMediaChange}
                                                            />
                                                            <img src={gallery} alt="Gallery" className="pr-2" /> Image
                                                        </label>

                                                        {/* Video Upload */}
                                                        <label className="flex items-center px-4 py-2 rounded-lg cursor-pointer">
                                                            <input
                                                                type="file"
                                                                accept="video/mp4,video/quicktime"
                                                                className="hidden"
                                                                onChange={handleVideoChange}
                                                            />
                                                            <img src={video} alt="Video" className="pr-2" /> Video
                                                        </label>
                                                        <button
                                                            className="flex items-center px-4 py-2 rounded-lg justify-between"
                                                            onClick={toggleTagInput}
                                                        >
                                                            <img src={taguser} alt="Tag" className="pr-2" /> Tag

                                                        </button>
                                                        {/* Display Selected Location */}


                                                        <button
                                                            className="flex items-center px-4 py-2 rounded-lg"
                                                            onClick={() => setShowLocationPage(true)}
                                                        >
                                                            <img src={Loacationtick} alt="Tag" className="pr-2" /> Check In
                                                        </button>
                                                        {selectedLocation && (
                                                            <div className="mt-2 text-sm text-gray-500">
                                                                <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                                                {selectedLocation}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Right Section (Dropdown & Post Button) */}
                                                    <div className="flex items-start post-ctas">
                                                        {/* Public Dropdown */}
                                                        <div className="pop-share-public">
                                                            <button
                                                                onClick={toggleDropdown}
                                                                className="share-public flex items-center px-4 py-2"
                                                            >
                                                                <img src={global} alt="Globe" className="pr-2" />
                                                                Public
                                                                <FaChevronDown className="ml-2 text-xs text-gray-400" />
                                                            </button>

                                                            {/* ✅ Show dropdown only if isOpen is true */}
                                                            {isOpen && (
                                                                <div className="relative bg-white shadow-md rounded-md  p-2">
                                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Post Button */}
                                                        <button onClick={handlePost} className="post-cta flex md:px-4 md:py-2 rounded-full mx-2" disabled={loading} // ✅ Disable button when loading
                                                        >
                                                            {loading ? "Posting..." : (
                                                                <>
                                                                    <img src={send} alt="Send" className="md:pr-2" /> <span>Post</span>
                                                                </>
                                                            )}
                                                        </button>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        {/* <div className="mt-4">
                            <h2 className="text-xl font-bold mb-2">Latest Posts</h2>

                            {loading && <p>Loading posts...</p>}

                            {posts?.length > 0 ? (
                                posts.map((post) => (
                                    <div key={post.id} className="share-content relative">
                                        <p><strong>User:</strong> {post.user_id}</p>
                                        <p><strong>Content:</strong> {post.content}</p>
                                        {post.media_url && (
                                            post.media_url.endsWith(".mp4") ? (
                                                <video src={post.media_url} controls width="100%" />
                                            ) : (
                                                <img src={post.media_url} alt="Post" width="100%" />
                                            )
                                        )}
                                        <p><strong>Tagged Users:</strong> {post.tagged_user_ids?.join(", ")}</p>
                                    </div>
                                ))
                            ) : (
                                <p>No posts available.</p>
                            )}
                        </div> */}
                        <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
                            <div className="flex  items-center gap-x-6 justify-between">
                                {/* <h2 className="text-3xl font-semibold tracking-tight text-balance text-black sm:text-4xl">
                                    Feeds
                                </h2> */}
                                <div className="filter bg-[] lg:p-3 flex space-x-4">
                                    {["Posts", "Friends", "Photos", "Videos"].map((tab) => (
                                        <button
                                            key={tab}
                                            className={`lg:p-3 ${activeTab === tab ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" : "text-black"
                                                } focus:outline-none`}
                                            onClick={() => setActiveTab(tab)}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Tab Content */}
                            <div className="mt-4">
                                {/* {activeTab === "Posts" && <div>
                                    {[1, 2, 3].map((post) => (
                                        <div key={post}>
                                            <div className="w-full ">
                                                {profileData.map((post, index) => (
                                                    <FeedPost key={index} post={post} />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>} */}

                                {activeTab === "Posts" && (
                                    <div>
                                        {/*  */}
                                        {loading && <p>Loading posts...</p>}
                                        <div className="w-full">
                                            {posts?.length > 0 ? (
                                                posts.map((post, index) => {
                                                    const maxLength = 150; // Character limit
                                                    const isExpanded = expandedPosts[index]; // Always read from state array

                                                    return (
                                                        <div>
                                                            <div key={index} className="mb-8">
                                                                <div className="feeds w-full bg-[#F7F7F7] p-8">
                                                                    <div className="flex items-center justify-between space-x-3">
                                                                        <div className="flex items-center">
                                                                            <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                                                                                <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-full h-full object-cover" />
                                                                            </div>
                                                                            <div className="feed-title pl-4">
                                                                                <p className="font-semibold">{post.user?.username || "Unknown User"}</p>
                                                                                <p className="flex text-sm text-[#747474]">
                                                                                    {post.date} |
                                                                                    <span className="flex items-center ml-1 cursor-pointer">
                                                                                        <img src={greenglobal} alt="" className="mr-1" /> Public
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        {/* ✅ Conditionally render Follow button based on myStatus */}
                                                                        {/* ✅ Conditionally render Follow button */}
                                                                        {!post.isOwn && (
                                                                            <button
                                                                                onClick={() => handleFollowClick(post.user_id, post.user?.privacy_status)}
                                                                                className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full ${post.myStatus === "accepted"
                                                                                    ? "bg-gray-400 text-white" // ✅ Following
                                                                                    : post.myStatus === "pending"
                                                                                        ? "bg-yellow-500 text-black" // ✅ Requested
                                                                                        : "bg-[#095228] text-white" // ✅ Follow (default)
                                                                                    }`}
                                                                                disabled={post.myStatus === "pending" || post.myStatus === "accepted"} // ✅ Disable after clicking
                                                                            >
                                                                                {post.myStatus === "accepted"
                                                                                    ? "Following"
                                                                                    : post.myStatus === "pending"
                                                                                        ? "Requested"
                                                                                        : "Follow"}
                                                                            </button>
                                                                        )}

                                                                    </div>
                                                                    {/* Post Content with Read More */}
                                                                    <p className="mt-4 mb-4 text-black text-justify break-all">
                                                                        {isExpanded ? post.content : `${post.content.slice(0, maxLength)}...`}
                                                                        {post.content.length > maxLength && (
                                                                            <button
                                                                                onClick={() => toggleReadMore(index)}
                                                                                className="text-[#095228] italic hover:underline font-semibold"
                                                                            >
                                                                                {isExpanded ? "Read Less" : "Read More"}
                                                                            </button>
                                                                        )}
                                                                    </p>

                                                                    {/* Media Handling */}
                                                                    <div
                                                                        className={`grid gap-2 
                                                                        ${post.media?.length === 1 ? "grid-cols-1"
                                                                                : post.media?.length === 2 ? "grid-cols-2"
                                                                                    : post.media?.length === 3 ? "grid-cols-3 xs:grid-cols-3 sm:grid-cols-5"
                                                                                        : post.media?.length === 4 ? "grid-cols-3 xs:grid-cols-5 sm:grid-cols-4"
                                                                                            : "grid-cols-5"} `}
                                                                    >
                                                                        {post.media?.map((media, imgIndex) => {
                                                                            const isPlaying = playingIndex === `${index}-${imgIndex}`;
                                                                            const isVideo = media.endsWith(".mp4") || media.endsWith(".webm") || media.endsWith(".ogg");

                                                                            return isVideo ? (
                                                                                <div key={imgIndex} className="relative w-full rounded-lg overflow-hidden hidden md:block">
                                                                                    <ReactPlayer
                                                                                        url={media}
                                                                                        playing={isPlaying}
                                                                                        controls
                                                                                        width="100%"
                                                                                        height={post.media.length === 1 ? "500px" : "100%"}
                                                                                        className="rounded-lg"
                                                                                        light={groupimg}
                                                                                        playIcon={
                                                                                            <button className="absolute inset-0 flex items-center justify-center bg-opacity-50 rounded-lg">
                                                                                                <img src={play} alt="Play" className="player" />
                                                                                            </button>
                                                                                        }
                                                                                        onClickPreview={() => setPlayingIndex(`${index}-${imgIndex}`)}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <img
                                                                                    key={imgIndex}
                                                                                    src={media}
                                                                                    alt={`Post ${index} Media ${imgIndex}`}
                                                                                    className="w-full h-full rounded-lg shadow-lg object-cover max-h-[300px]"
                                                                                />
                                                                            );
                                                                        })}
                                                                    </div>
                                                                    {/* Social Buttons */}
                                                                    <div className="react-social-cta flex justify-between items-center mt-8">
                                                                        <div className="flex space-x-4">
                                                                            <button
                                                                                onClick={() => handleLikeClick(post.id)}
                                                                                onMouseDown={() => handleLongPressStart(post.id)} // Start long press
                                                                                onMouseUp={handleLongPressEnd} // End long press
                                                                                onTouchStart={() => handleLongPressStart(post.id)} // For mobile: Start long press
                                                                                onTouchEnd={handleLongPressEnd} // For mobile: End long press

                                                                                className="like flex items-center space-x-1 bg-[#BE1F2E] text-white px-3 py-1">
                                                                                <img src={likeIcon} alt="Like" className="mr-1" /> {post.likeCount}
                                                                            </button>
                                                                            <Modal
                                                                                isOpen={isModalOpen}
                                                                                onRequestClose={closeModal}
                                                                                contentLabel="Liked Users"
                                                                                className="modal"
                                                                                overlayClassName="overlay"
                                                                            >
                                                                                <h2 className="text-xl font-bold mb-4">Users who liked this post</h2>
                                                                                <ul>
                                                                                    {likedUsers?.map((user, index) => (
                                                                                        <li key={index} className="mb-2">
                                                                                            <img
                                                                                                src={user.profile_picture_url || profileimg}
                                                                                                alt={user.username}
                                                                                                className="w-8 h-8 rounded-full inline-block mr-2"
                                                                                            />
                                                                                            {user.username}
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                                <button
                                                                                    onClick={closeModal}
                                                                                    className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                                                                >
                                                                                    Close
                                                                                </button>
                                                                            </Modal>
                                                                            <button
                                                                                onClick={() => toggleCommentSection(post.id)} // Toggle comment section
                                                                                onMouseDown={() => handleCommentLongPressStart(post.id)} // Start long press
                                                                                onMouseUp={handleCommentLongPressEnd} // End long press
                                                                                onTouchStart={() => handleCommentLongPressStart(post.id)} // For mobile: Start long press
                                                                                onTouchEnd={handleCommentLongPressEnd} // For mobile: End long press

                                                                                className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1">
                                                                                <img src={commentIcon} alt="Comment" className="mx-1 space-x-1 px-2 py-1" /><span className="cursor-pointer"> {post.commentCount}</span>
                                                                            </button>
                                                                            <button className="eye flex items-center space-x-1 text-black">
                                                                                <img src={viewIcon} alt="Views" className="mr-1" /> {post.viewsCount} Views
                                                                            </button>
                                                                        </div>
                                                                        <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                                                            <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                                                                        </button>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                            {/* Comment Section */}
                                                            <div className="hidden md:block">
                                                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true

                                                                    <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                                                        <div className="flex items-center w-full">
                                                                            <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Add a comment..."
                                                                                value={commentInputs[post.id] || ""} // Bind input to state
                                                                                onChange={(e) =>
                                                                                    handleCommentChange(post.id, e.target.value)
                                                                                }
                                                                                className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                                                            />
                                                                        </div>
                                                                        <div className="flex space-x-2">
                                                                            <button>
                                                                                <img src={smileyIcon} alt="Smiley" className="w-8" />
                                                                            </button>
                                                                            <button
                                                                                onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                                                                className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                                                                Send
                                                                            </button>
                                                                            {/* Modal for Comments */}
                                                                            <Modal
                                                                                isOpen={isCommentsModalOpen}
                                                                                onRequestClose={closeCommentsModal}
                                                                                contentLabel="Comments"
                                                                                className="modal"
                                                                                overlayClassName="overlay"
                                                                            >
                                                                                <h2 className="text-xl font-bold mb-4">Comments</h2>
                                                                                <ul>
                                                                                    {comments.map((comment, index) => (
                                                                                        <li key={index} className="mb-2">
                                                                                            <p className="font-bold">{comment.user?.username || "Unknown User"}</p>
                                                                                            <p className="text-sm text-gray-500">{comment.content}</p>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                                <button
                                                                                    onClick={closeCommentsModal}
                                                                                    className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                                                                >
                                                                                    Close
                                                                                </button>
                                                                            </Modal>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className="text-center text-gray-500">No posts available.</p>
                                            )}
                                        </div>

                                    </div>
                                )}


                                {activeTab === "Friends" &&
                                    <div className="friends-tab">
                                        <div className="flex relative w-full ">
                                            <div className="fasearch">
                                                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" /></div>
                                            <input
                                                type="text"
                                                placeholder="Find Your Friend"
                                                className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300 text-[#000]"
                                            />

                                        </div>
                                        {followers.length > 0 ? (
                                            followers.map((user) => (
                                                <div
                                                    key={user.id}
                                                    className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                                                >
                                                    <div className="flex">
                                                        <img
                                                            src={user.profile_picture_url || userimg}
                                                            alt="User"
                                                            className="w-15 h-15 rounded-full"
                                                        />
                                                        <div className="pl-4">
                                                            <p className="titlesemibold pb-1">{user.first_name}</p>
                                                            <p className="text-[12px] text-[#747474] pb-1">@{user.username}</p>
                                                            <p className="members">
                                                                {user.user1FollowersCount} Followers{" "}
                                                                <span className="text-[#D9D9D9] px-1">|</span>{" "}
                                                                <span className="italic text-[#095228b8] text-[10px] underline">
                                                                    {user.mutualFriendsCount} Mutual Followers
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="flex follow-unfollow-cta">
                                                        {user.isBlocked ? (
                                                            <button
                                                                className="unblock-cta my-2 bg-green-500 text-white px-4 py-2 rounded"
                                                                onClick={() => handleUnblockFollower(user.id)}
                                                            >
                                                                Unblock
                                                            </button>
                                                        ) : (
                                                            <>
                                                                {user.myStatus === null && user.friendStatus === "accepted" ? (
                                                                    followedUsers[user.id] ? (
                                                                        <>
                                                                            <button
                                                                                className="follow-cta my-2 bg-[#BE1F2E]"
                                                                                onClick={() => handleUnfollow(user.id)}
                                                                            >
                                                                                Unfollow
                                                                            </button>
                                                                            <button
                                                                                className="follow-cta-block  bg-[#BE1F2E]"
                                                                                onClick={() => handleBlockFollower(user.id)}
                                                                            >
                                                                                Block
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <button
                                                                            className="text-[12px] bg-[#095228] text-[#fff] py-2 px-4 rounded-full font-semibold"
                                                                            onClick={() => handleFollowBack(user.id)}
                                                                        >
                                                                            Follow Back
                                                                        </button>
                                                                    )
                                                                ) : (
                                                                    <button
                                                                        className="follow-cta-block  bg-[#BE1F2E]"
                                                                        onClick={() => handleBlockFollower(user.id)}
                                                                    >
                                                                        Block
                                                                    </button>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center text-gray-500 mt-4">You have no followers.</p>
                                        )}
                                    </div>}
                                {activeTab === "Photos" &&
                                    <div className="relative  h-[600px] overflow-y-scroll">
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                            <div className="grid gap-4">
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src={postone} alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src={posttwo} alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src={postthree} alt="" />
                                                </div>
                                            </div>
                                            <div className="grid gap-4">
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src={postone} alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src={postone} alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-5.jpg" alt="" />
                                                </div>
                                            </div>
                                            <div className="grid gap-4">
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-6.jpg" alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-7.jpg" alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-8.jpg" alt="" />
                                                </div>
                                            </div>
                                            <div className="grid gap-4">
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-9.jpg" alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-10.jpg" alt="" />
                                                </div>
                                                <div>
                                                    <img className="h-auto max-w-full w-full rounded-lg" src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-11.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* White Shade Blur Effect */}
                                        <div className="sticky bottom-0 left-0 w-full h-[50%] bg-gradient-to-t from-[#ffffffa3] to-transparent pointer-events-none" />
                                    </div>
                                }
                                {activeTab === "Videos" && (
                                    <div className="relative  h-[600px] overflow-y-scroll">
                                        <div
                                            className={`grid gap-4 
                                        sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3
                                        auto-rows-[auto]`} // Masonry grid effect
                                            style={{ columnGap: '1rem', minHeight: '600px' }}
                                        >
                                            {videoUrls.map((url, index) => (
                                                <div
                                                    key={index}
                                                    className={`break-inside-avoid overflow-hidden rounded-lg shadow-md object-cover w-full h-[250px] h-full
                                                ${index % 3 === 0 ? "row-span-2" : index % 4 === 0 ? "row-span-3" : "row-span-1"}`}
                                                >
                                                    <div className="h-full max-w-full w-full rounded-lg overflow-hidden">
                                                        <ReactPlayer
                                                            url={url}
                                                            playing={playingIndex === index}
                                                            controls
                                                            width="100%"
                                                            height="100%"
                                                            className="rounded-lg h-full profilepost-control"
                                                            light={groupimg}
                                                            playIcon={(
                                                                <button
                                                                    className="relative inset-0 flex items-center justify-center bg-[#D9D9D980] bg-opacity-50 rounded-full p-3"
                                                                    onClick={() => setPlayingIndex(index)}
                                                                >
                                                                    <img src={play} alt="Play" className="w-12 h-12" />
                                                                </button>
                                                            )}
                                                            onClickPreview={() => setPlayingIndex(index)}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        {/* White Shade Blur Effect */}
                                        <div className="sticky bottom-0 left-0 w-full h-[50%] bg-gradient-to-t from-[#ffffffa3] to-transparent pointer-events-none" />
                                    </div>

                                )}
                            </div>
                        </div>
                        {/* <RightResponsivesidebar /> */}
                    </div>
                    {/* Right Sidebar */}
                    <Rightsidebar />
                </main>
            </main>
        </div >
    );
}
